import React, { useEffect, useState } from 'react'

//interfaces
import { DropdownGroupInfo, IBasicGroup} from  '@/interfaces/orgSettings';
import { IconLibrary } from  '@/interfaces/IconLibrary';

//helpers
import { Truncate } from  '@/helpers/Text';

//components
import Icon from  '@/components/elements/icons/Icons';

//api
import { getOrganisationGroupListForUser } from '@/api/orgSettings/users';



const UseUserRoleGroups = (userId) => {  
    const [groups, setGroups] = useState<DropdownGroupInfo[]>();
    const [groupsData, setGroupsData] = useState(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [displayTooltip, setDisplayTooltip] = useState<boolean>(false);
    const [extraDetailText, setExtraDetailText] = useState<string>("");
    const maxRecordsToDisplay = 6;

    useEffect(() => {
        if (userId && displayTooltip) {
            getUsersGroupData();        
        }
    }, [displayTooltip])

    useEffect(() => {
        if (groupsData?.length > 0) {
            const newGroups: DropdownGroupInfo[] = groupsData.map((userGroup) => ({
                title: Truncate(userGroup.name, 18),
                subtitle: userGroup.permission === "manage" ? "Admin" : "Member",
                displayIcon: true,
                icon: <Icon iconName={IconLibrary.USERS} sizeInPx="18" color="#343D4C" />,
            }));
            setGroups(newGroups);
        }
        setIsLoading(false);
    }, [groupsData]);

    function getUsersGroupData() {
        if (!userId) { return }
        
        setIsLoading(true);
        getOrganisationGroupListForUser(userId)
        .then(({records, total}: IBasicGroup) => {
            const recordsToDisplay = records.slice(0, maxRecordsToDisplay);
            setGroupsData(recordsToDisplay);
            if (total > maxRecordsToDisplay) {
                setExtraDetailText(`+${total - maxRecordsToDisplay} more ${total - maxRecordsToDisplay > 1 ? "groups" : "group"}`);
            } else {
                setExtraDetailText('');
            }       
        })
        .catch((error) => {
            console.error("Issue getting user groups data", error)
        });
    }

    return{isLoading, groups, displayTooltip, setDisplayTooltip, extraDetailText}
}

export default UseUserRoleGroups